import { useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import Sidebar from '../../../layout/Sidebar/Sidebar';

const ModuleNewsletterManagerSideBarReports = () => {
  const auth = useSelector((state) => state.auth);

  return (
    <Sidebar>
      <img
        src={auth.user?.client?.logoUrl}
        className="img-fluid"
        alt={auth.user?.client?.name}
        title={auth.user?.client?.name}
      />
      <Accordion>
        <ul>
          {/* <li>
            <AppLink
              href={`${global.urlData.userApiUrl}m/comsa-reports/get-xls-report/${moduleBridgeHex}/${subModuleBridgeHex}/${plantHex}/`}
              className="p-0"
            >
              <span
                className="sidebar-element"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-comsaReports"
                    name="download.report"
                  />
                )}
              >
                <AppRemixIcon icon="file-excel-2" className="sidebar-icon" />
                <span className="sb-title">
                  <Translator
                    file="module-comsaReports"
                    name="download.report"
                  />
                </span>
              </span>
            </AppLink>
          </li> */}
        </ul>
      </Accordion>
    </Sidebar>
  );
};

export default ModuleNewsletterManagerSideBarReports;
